<template>
    <div class="computerBox">
        <topBox :title="title" />
        <div class="px-[36px] w-full mt-[80px]">

            <p class="mb-4 text-14 text-slate-400 leading-relaxed">{{ $t('text.inviteLinkTip') }}</p>

            <div class="my-2">
                <h1 class="text-m14 font-semibold text-slate-900 text-left mb-[10px]">{{ $t('but.downloadQr') }}</h1>
                <div class="flex flex-col items-center rounded-[24px] border bg-white p-6 shadow-lg">
                    <canvas ref="qrCanvas" class="block h-[200px] w-[200px]"></canvas>
                </div>
                <div class="mt-3 py-[10px]">
                    <button
                        type="button"
                        class="block w-full px-5 py-[15px] border rounded-full butSubmit text-white shadow-lg focus:ring-1 focus:outline-none text-xs-xs"
                        @click="downloadQr"
                    >
                        {{ $t('but.downloadQr') }}
                    </button>
                </div>
            </div>

            <div class="my-2 ">
                <h1 class="text-m14 font-semibold text-slate-900 text-left mb-[10px]">{{ $t('text.inviteRegisterLink') }}</h1>
                <input
                    type="text"
                    readonly
                    class="block w-full px-[35px] py-[15px] border rounded-full bg-white shadow-lg text-gray-700 focus:ring-1 focus:outline-none text-ms"
                    :value="inviteUrl"
                />
                <div class="mt-3 py-[10px] mb-12">
                    <button
                        type="button"
                        class="block w-full px-5 py-[15px] border rounded-full shadow-lg focus:ring-1 focus:outline-none text-xs-xs transition-colors"
                        :class="copied ? 'bg-slate-100 text-green-600' : 'butSubmit text-white'"
                        @click="copyLink"
                    >
                        {{ copied ? $t('but.copied') : $t('but.copy') }}
                    </button>
                </div>
            </div>



        </div>
        <mainMenu />
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import QRCode from 'qrcode'
import topBox from '@/components/computer/TopBox.vue'
import mainMenu from '@/components/computer/MainMenu.vue'
import axios from 'axios'
import { layer } from 'vue3-layer'
import { useGlobalStore } from '@/assets/js/globalStore'

export default {
    components: {
        topBox,
        mainMenu,
    },
    data() {
        return {
            title: this.$t('page.inviteLink'),
            lang: '',
            inviteCode: '',
            inviteUrl: '',
            copied: false,
            copyTimer: null,
        }
    },
    mounted() {
        const { locale } = useI18n()
        this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : locale.value
        locale.value = this.lang
        this.getInfo()
    },
    beforeUnmount() {
        if (this.copyTimer) {
            clearTimeout(this.copyTimer)
        }
    },
    methods: {
        getInfo() {
            axios.post(
                '/api/m/info/user',
                {},
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept-Language': this.lang,
                        token: localStorage.getItem('token'),
                    },
                }
            )
            .then((response) => {
                if (response.data.code === 0) {
                    this.inviteCode = response.data.data.uuid || ''
                    const globalStore = useGlobalStore()
                    globalStore.setId(this.inviteCode)
                    globalStore.setInvite(this.inviteCode)
                    this.buildInviteUrl()
                    this.$nextTick(() => this.renderQr())
                } else {
                    layer.msg(response.data.msg)
                }
            })
            .catch((error) => {
                console.log(error)
            })
        },
        buildInviteUrl() {
            const base = window.location.origin
            if (!this.inviteCode) {
                this.inviteUrl = ''
                return
            }
            // 与 ShareGuys 一致，将邀请码写入路径参数，避免 query 在跳转中丢失
            this.inviteUrl = `${base}/computer/register/invite/${this.inviteCode}`
        },
        renderQr() {
            const canvas = this.$refs.qrCanvas
            if (!canvas || !this.inviteUrl) return
            QRCode.toCanvas(canvas, this.inviteUrl, {
                width: 200,
                margin: 2,
                color: {
                    dark: '#22c55e',
                    light: '#ffffff',
                },
            }).catch((err) => {
                console.log(err)
            })
        },
        copyLink() {
            const text = this.inviteUrl
            if (!text) return

            const done = () => {
                this.copied = true
                if (this.copyTimer) clearTimeout(this.copyTimer)
                this.copyTimer = setTimeout(() => {
                    this.copied = false
                }, 2000)
                layer.msg(this.$t('text.copySuccess'))
            }

            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text).then(done).catch(() => {
                    this.fallbackCopy(text, done)
                })
            } else {
                this.fallbackCopy(text, done)
            }
        },
        fallbackCopy(text, done) {
            const input = document.createElement('textarea')
            input.value = text
            input.style.position = 'fixed'
            input.style.opacity = '0'
            document.body.appendChild(input)
            input.select()
            try {
                document.execCommand('copy')
                done()
            } catch (e) {
                layer.msg(this.$t('text.copyFailed'))
            }
            document.body.removeChild(input)
        },
        downloadQr() {
            const canvas = this.$refs.qrCanvas
            if (!canvas) return
            const link = document.createElement('a')
            link.download = `invite-${(this.inviteCode || 'qr').slice(0, 8)}.png`
            link.href = canvas.toDataURL('image/png')
            link.click()
        },
    },
}
</script>

<style lang="scss" scoped>
.computerBox {
    /* background: url('https://tdkt06.com/img/headbg2x.1c5aca6e.png') 0% 0% / 100% no-repeat; */
}
</style>
